import moment from 'moment';

export const fullDateFormat = 'MMM D, YYYY';

export function formatDate(date: string|null): string {
  if (!date) return 'TBD';
  return moment(date).format(fullDateFormat);
}
